/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2022-01-26T10:50:44.549
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveFinancialTransferOprLog,
	getFinancialTransferOprLogCreateInit,
	getFinancialTransferOprLogEditInit,
	getFinancialTransferOprLogView,
	deleteFinancialTransferOprLog
} from '@api/financial/FinancialTransferOprLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getFinancialTransferOprLogCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialTransferOprLogCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialTransferOprLogEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialTransferOprLogEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialTransferOprLog({}, FinancialTransferOprLog) {
			return new Promise((resolve, reject) => {
				saveFinancialTransferOprLog(FinancialTransferOprLog)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getFinancialTransferOprLogView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialTransferOprLogView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteFinancialTransferOprLog({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialTransferOprLog({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
